import { bucketManualItemForDisplay } from './netWorth';

// Reconcile just the edited record, never a whole pre-edit snapshot: independent
// changes can finish in any order without rolling each other back.
export const applyAccountInclusion = (summary, accountId, ignored, version) => {
  if (!summary) return summary;
  const account = summary.accounts?.find((row) => String(row.accountId) === String(accountId));
  if (!account) return summary;
  const changed = account.isIgnored !== ignored;
  const amount = Number(account.netWorthAmount ?? account.currentBalance);
  const delta = changed ? (ignored ? -1 : 1) * (account.isLiability ? Math.abs(amount) : amount) : 0;
  const totalAssets = Number(summary.totalAssets) + (account.isLiability ? 0 : delta);
  const totalLiabilities = Number(summary.totalLiabilities) + (account.isLiability ? delta : 0);
  const category = account.isLiability ? 'debt' : (account.netWorthCategory || account.category || 'cash');
  const key = category === 'other_assets' ? 'otherAssets' : category;
  return { ...summary, totalAssets, totalLiabilities, netWorth: totalAssets - totalLiabilities,
    breakdown: { ...summary.breakdown, [key]: Number(summary.breakdown?.[key] || 0) + delta },
    accounts: summary.accounts.map((row) => String(row.accountId) === String(accountId)
      ? { ...row, isIgnored: ignored, ...(version == null ? {} : { version }) } : row) };
};

export const adjustManualItem = (summary, item, removing) => {
  if (!summary) return summary;
  const exists = summary.manualItems?.some((candidate) => String(candidate.id) === String(item.id));
  if (removing !== Boolean(exists)) return summary;
  const group = bucketManualItemForDisplay(item.itemType);
  const delta = (removing ? -1 : 1) * Number(item.estimatedValue);
  const totalAssets = Number(summary.totalAssets) + (group === 'debt' ? 0 : delta);
  const totalLiabilities = Number(summary.totalLiabilities) + (group === 'debt' ? delta : 0);
  const key = group === 'other_assets' ? 'otherAssets' : group;
  return { ...summary, totalAssets, totalLiabilities, netWorth: totalAssets - totalLiabilities,
    breakdown: { ...summary.breakdown, [key]: Number(summary.breakdown?.[key] || 0) + delta },
    manualItems: removing ? summary.manualItems.filter((candidate) => String(candidate.id) !== String(item.id))
      : [...(summary.manualItems || []), item] };
};
